import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-incidents-add-hyperlink-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class IncidentsAddHyperlinkManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel> {
            name: "Add Hyperlink to Incident",
            description: "This endpoint can be used to add a hyperlink to an existing incident.",
            httpMethod: "POST",
            path: "/api/incidents/{guid}/add/hyperlink",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the incident to add the hyperlink to",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "name",
                    description: "name of the hyperlink",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "hyperlink name",
                },
                {
                    name: "hyperlink",
                    description: "hyperlink to add to the incident",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "https://www.example.com",
                },
                {
                    name: "description",
                    description: "description of the hyperlink",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "hyperlink description",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                }
            ]
        }
    }
}